import { render, staticRenderFns } from "./AudioPropertiesPanel.vue?vue&type=template&id=5e42531d&scoped=true"
import script from "./AudioPropertiesPanel.vue?vue&type=script&lang=js"
export * from "./AudioPropertiesPanel.vue?vue&type=script&lang=js"
import style0 from "./AudioPropertiesPanel.vue?vue&type=style&index=0&id=5e42531d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42531d",
  null
  
)

export default component.exports